import React from 'react';
import { useSelector } from 'react-redux';
import './index.scss';

const FormInput = ({
  unique,
  label,
  type = 'text',
  value = '',
  error = '',
  options = [],
  required = false,
  internalUsage = false,
  minLength = undefined,
  maxLength = undefined,
  wasSubmitPressed = false,
  onChange = () => {},
}) => {
  const translations = useSelector((store) => store.config.Translations);

  return (
    <div className="forum-input-container">
      <label
        htmlFor={`${unique}-form-input`}
        className="form-input-label"
      >
        {label}
        {(required || internalUsage) && (
          <span className="input-note">
            {' ('}
            {required && translations['forum_required_field']}
            {required && internalUsage && ' - '}
            {internalUsage && translations['forum_internal_usage_field']}
            {')'}
          </span>
        )}
      </label>

      {(() => {
        switch (type) {
          case 'textarea':
            return (
              <textarea
                id={`${unique}-form-input`}
                name={unique}
                value={value}
                onChange={onChange}
                className="form-input-element"
                required={required}
                minLength={minLength}
                maxLength={maxLength}
              />
            );

          case 'select':
            return (
              <select
                id={`${unique}-form-input`}
                name={unique}
                value={value}
                onChange={onChange}
                className="form-input-element"
                required={required}
              >
                <option value="">{translations['forum_option_not_chosen']}</option>
                {options.map((option) => (
                  <option key={option.id} value={option.text}>
                    {option.text}
                  </option>
                ))}
              </select>
            );

          default:
            return (
              <input
                id={`${unique}-form-input`}
                type={type}
                name={unique}
                value={value}
                onChange={onChange}
                className="form-input-element"
                required={required}
                minLength={minLength}
                maxLength={maxLength}
              />
            );
        }
      })()}

      {error !== '' && wasSubmitPressed && (
        <p className="field-error-message">{error}</p>
      )}
    </div>
  );
};

export default FormInput;
